import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import PhoneInTalkOutlinedIcon from '@mui/icons-material/PhoneInTalkOutlined';
import { useVoice } from './VoiceContext';
import { callIdFromMemo, canOpenCall } from './callFormat';
import CallDetailDialog from './CallDetailDialog';

/**
 * Phone icon on a memo that was written from a call: opens the call dialog (recording + full
 * transcript). Renders nothing for ordinary memos or for admins without the call permission.
 * When the memo carries the call's owner (memo.call_log.admin_id) the icon is disabled for admins
 * who may not open it; otherwise the server decides on click and the dialog shows its answer.
 */
const MemoCallButton = ({ memo, size = 16, sx }) => {
    const voice = useVoice();
    const [open, setOpen] = useState(false);
    const callId = callIdFromMemo(memo);
    if (!callId || !voice?.permitted) return null;
    const knownOwner = memo.call_log?.admin_id != null;
    const enabled = knownOwner ? canOpenCall(voice.me, memo.call_log) : true;
    const title = enabled
        ? `Open call #${callId}: recording and full transcript`
        : 'Placed by another admin — only they, or an admin listed in VOICE_ADMIN_EMAILS, can open it';
    return (
        <>
            <Tooltip title={title}>
                <span>
                    <IconButton
                        size="small"
                        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
                        disabled={!enabled}
                        aria-label={`Open call #${callId}`}
                        sx={{ p: 0.25, ...sx }}
                    >
                        <PhoneInTalkOutlinedIcon sx={{ fontSize: size }} color={enabled ? 'primary' : 'disabled'} />
                    </IconButton>
                </span>
            </Tooltip>
            {enabled && <CallDetailDialog callId={callId} open={open} onClose={() => setOpen(false)} />}
        </>
    );
};

export default MemoCallButton;
